import { Component } from '@angular/core';

@Component({
  selector: 'app-almacen-menajeria',
  templateUrl: './almacen-menajeria.component.html',
  styleUrls: ['./almacen-menajeria.component.scss'],
})
export class AlmacenMenajeriaComponent {
  constructor() {}
}
